import React from 'react';

export type GetComponentProps<P> = P extends React.ComponentType<infer P> | React.Component<infer P> ? P : never;

export const getComponentDisplayName = (ComponentForInspect: React.ComponentType<any>) => {
  return ComponentForInspect.displayName || ComponentForInspect.name || 'Component';
};
